var divider_viewer_rtlignore_default = {
  "divider-container": "_78kdO",
  "divider-container--double": "Weq40",
  "divider": "p-NVp",
  "divider--single": "_5UScS",
  "divider--double": "E4JKm",
  "divider--dashed": "rQpOO",
  "divider--dotted": "_8yCHl",
  "divider--small": "ODu2c",
  "divider--small--mobile": "x4wHN",
  "divider--medium": "dTJ09",
  "divider--large--mobile": "hEtxG",
  "divider--medium--mobile": "_1xvEu",
  "divider--large": "S-r4T",
  "divider--left": "DjIm5",
  "divider--center": "NIvln",
  "divider--right": "JIQvf",
  "divider--fill-parent": "gLPfp",
  "svgFixerContainer": "_1PrLh",
  "emptyChar": "yuGZF"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
